var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rightSide", class: _vm.bottBox ? "" : "rightclose" },
    [
      _c("img", {
        staticClass: "collImg",
        class: _vm.bottBox ? "collpase" : "collclose",
        attrs: { src: _vm.collImg },
        on: { click: _vm.toggle },
      }),
      _c("div", { staticClass: "sidebox" }, [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }